import { render, staticRenderFns } from "./TemplatePageLayout.vue?vue&type=template&id=07bb9e0c&scoped=true"
import script from "./TemplatePageLayout.vue?vue&type=script&lang=js"
export * from "./TemplatePageLayout.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07bb9e0c",
  null
  
)

export default component.exports